module.exports = __webpack_public_path__ + "static/media/RASM_Logo FULL_2019_CMYK_1725636423177.379dced0.eps";